// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f0ab92c","787":"38edc268"}[chunkId] + ".chunk.js";
};